import { i18n } from '@shared/util/i18n';

// How long the view waits after the last change to its search or filters before it queries, and
// how long the search box inside a filter's picker waits before it looks up options.
export const QUERY_DEBOUNCE_MS = 500;

export const containsOperator = {
  label: i18n('card.actions.filters.fields.common.operator.contains'),
  id: 'contains',
};

export const emptyOperator = {
  label: i18n('card.actions.filters.fields.date.operator.empty'),
  id: 'empty',
};

export const notEmptyOperator = {
  label: i18n('card.actions.filters.fields.common.operator.notEmpty'),
  id: 'notEmpty',
};

export const doesNotContainOperator = {
  label: i18n('card.actions.filters.fields.common.operator.doesNotContain'),
  id: 'does-not-contain',
};

// Defers to a field on the card being edited rather than to a value - only ever offered where
// the menu was given fields to match against (see `useFilterOperators`).
export const matchesOperator = {
  label: i18n('card.actions.filters.fields.common.operator.matches'),
  id: 'matches',
};

export const basicOperators = [emptyOperator, notEmptyOperator, containsOperator];
